import type { SearchResultItem } from "@/client"
import { FlashcardContent } from "@/components/Flashcards/FlashcardContent"
import { FlashcardSaveNoteModal } from "@/components/Flashcards/FlashcardSaveNoteModal"
import { Badge, Box, Button, Flex, Heading, Stack } from "@chakra-ui/react"
import { useState } from "react"

interface FlashcardResultCardProps {
  item: SearchResultItem
}

export function FlashcardResultCard({ item }: FlashcardResultCardProps) {
  const [showAnswer, setShowAnswer] = useState(false)

  const subjectNames = item.subject_names ?? []

  return (
    <Box borderWidth="1px" borderRadius="lg" bg="bg.surface" p={4}>
      <Stack gap={3}>
        <Flex gap={2} wrap="wrap">
          {item.deck_name && (
            <Badge colorPalette="blue" variant="subtle">
              {item.deck_name}
            </Badge>
          )}
          {subjectNames.map((subject) => (
            <Badge key={subject} colorPalette="teal" variant="subtle">
              {subject}
            </Badge>
          ))}
        </Flex>

        <Heading size="sm" lineHeight="1.35">
          <FlashcardContent content={item.front ?? ""} />
        </Heading>

        <Flex gap={2} wrap="wrap" align="center">
          <Button
            size="xs"
            variant="outline"
            onClick={() => setShowAnswer((open) => !open)}
          >
            {showAnswer ? "Hide answer" : "Show answer"}
          </Button>
          {/* Always enabled: FlashcardUserNote is keyed on the card alone, and
              search has already resolved deck accessibility for this caller,
              so there is no per-card gate the way there is for questions. */}
          <FlashcardSaveNoteModal
            card={{
              id: item.id,
              deck_id: item.deck_id ?? "",
              deck_name: item.deck_name ?? undefined,
              front: item.front ?? "",
              back: item.back ?? "",
            }}
          />
        </Flex>

        {showAnswer && (
          <Box
            bg="bg.subtle"
            borderWidth="1px"
            borderColor="border"
            borderRadius="md"
            p={3}
          >
            <FlashcardContent content={item.back ?? ""} color="fg.muted" />
          </Box>
        )}
      </Stack>
    </Box>
  )
}
